import GidsCallbackRequestPage from './gids-callback-request-container'

export default GidsCallbackRequestPage
